
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import { GetLaiLoByPhanTramThau, GetTextTienHoi, TinhTienHoi } from "./reportTemplete";
/* Mẫu 4: miền tây
Thứ…, ngày… Khách
Tên khách
MN: 2C…da…dx… 3C…4C… (tiền qua cò)
Trúng: 2C… da…dx…3C…4C…(tiền trúng)
(Nếu là chuyển cho Chủ)
Thu = Lãi hay Bù = Lỗ * 0.95
(Nếu là nhận của khách)
Thu = Lãi * 0.95 hay Bù = Lỗ
*/
type groupItemList = '2CB' | '2CDD' | '3CB' | '3CXC' | '4C' | 'da' | 'XMB'
export const templeteMienTay_details: { [key: string]: groupItemList } = {
    "6Lo2c": "2CB",
    "DKC": "2CB",
    '6Lo3C': '3CB',
    '7Lo2C': '2CB',
    '8Lo2C': '2CB',
    '7Lo3C': '3CB',
    'DaT': 'da',
    'Dau2C': '2CDD',
    'Dau4C': '4C',
    'DaX': 'da',
    'Duoi2C': '2CDD',
    'Duoi4C': '4C',
    'Lo2C': '2CB',
    'Lo3C': '3CB',
    'Lo4C': '4C',
    'XC': '3CXC',
    'XcDau': '3CXC',
    'XcDuoi': '3CXC',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
export const templeteMienTay_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        '2CB': 0,
        '2CDD': 0,
        'da': 0,
        'dx': 0,
        '3CB': 0,
        '3CXC': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    Xac: {
        '2CB': 0,
        '2CDD': 0,
        'da': 0,
        'dx': 0,
        '3CB': 0,
        '3CXC': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    //Tiền thưởng
    Trung: {
        '2C': 0,
        'da': 0,
        'dx': 0,
        '3C': 0,
        '4C': 0,
        'XMB': 0
    } as { [key: string]: number },
    TienTrung: {
        '2C': 0,
        'da': 0,
        'dx': 0,
        '3C': 0,
        '4C': 0,
        'XMB': 0
    } as { [key: string]: number },
    GetLaiLo: function () {
        let quaCo = 0;
        let tienThuong = 0;
        Object.keys(this.QuaCo).forEach(key => {
            quaCo += this.QuaCo[key];
        })
        Object.keys(this.TienTrung).forEach(key => {
            tienThuong += this.TienTrung[key];
        })
        return quaCo - tienThuong;
    },
    GetSMS: function () {
        let sms = "";
        sms += this.MIEN + ":"
        if (this.QuaCo['2CB'] != 0) {
            sms += `2CB:${tienFormat(this.Xac['2CB'], 1)}=`
            sms += `${tienFormat(this.QuaCo['2CB'], 1)}n\r\n`
        }
        if (this.QuaCo['2CDD'] != 0) {
            sms += `2CDD:${tienFormat(this.Xac['2CDD'], 1)}=`
            sms += `${tienFormat(this.QuaCo['2CDD'], 1)}n\r\n`
        }
        if (this.QuaCo['da'] != 0) {
            sms += `da:${tienFormat(this.Xac['da'], 1)}=`
            sms += `${tienFormat(this.QuaCo['da'], 1)}n\r\n`
        }
        if (this.QuaCo['dx'] != 0) {
            sms += `dx:${tienFormat(this.Xac['dx'], 1)}=`
            sms += `${tienFormat(this.QuaCo['dx'], 1)}n\r\n`
        }
        if (this.QuaCo['3CB'] != 0) {
            sms += `3CB:${tienFormat(this.Xac['3CB'], 1)}=`
            sms += `${tienFormat(this.QuaCo['3CB'], 1)}n\r\n`
        }
        if (this.QuaCo['3CXC'] != 0) {
            sms += `3CXC:${tienFormat(this.Xac['3CXC'], 1)}=`
            sms += `${tienFormat(this.QuaCo['3CXC'], 1)}n\r\n`
        }
        if (this.QuaCo['4C'] != 0) {
            sms += `4C:${tienFormat(this.Xac['4C'], 1)}=`
            sms += `${tienFormat(this.QuaCo['4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB:${tienFormat(this.Xac['XMB'], 1)}=`
            sms += `${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }
        //tien thuong
        let tmp = ""
        if (this.TienTrung['2C'] != 0) {
            tmp += `2c:${this.Trung['2C']}=${tienFormat(this.TienTrung['2C'], 1)}n\r\n`
        }
        if (this.TienTrung['da'] != 0) {
            tmp += `da:${this.Trung['da']}=${tienFormat(this.TienTrung['da'], 1)}n\r\n`
        }
        if (this.TienTrung['dx'] != 0) {
            tmp += `dx:${this.Trung['dx']}=${tienFormat(this.TienTrung['dx'], 1)}n\r\n`
        }
        if (this.TienTrung['3C']! + 0) {
            tmp += `3c:${this.Trung['3C']}=${tienFormat(this.TienTrung['3C'], 1)}n\r\n`
        }
        if (this.TienTrung['4C'] != 0) {
            tmp += `4c:${this.Trung['4C']}=${tienFormat(this.TienTrung['4C'], 1)}n\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB:${this.Trung['XMB']}=${tienFormat(this.TienTrung['XMB'], 1)}n\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        const laiLoSauPt = laiLo / 100 * (100 - this.message.phanTramThau)
        const tienHoiSauPt = TinhTienHoi(this.message)
        if (laiLo > 0) {
            sms += "\r\nThu:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            sms += "\r\nBù:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function getSMSMauMienTay(messages1: any) {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templeteMienTay_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templeteMienTay_total = _.cloneDeep(templeteMienTay_total);
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        curSms.message = msg
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau;
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templeteMienTay_details[loaiCuocId];
                switch (loaiCuocId) {
                    case "6Lo2c":
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CB"] += item.quaCo
                        curSms.Xac["2CB"] += item.xac
                        break;
                    case "DKC":
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung
                        curSms.QuaCo["2CB"] += item.quaCo
                        curSms.Xac["2CB"] += item.xac
                        break;
                    case '6Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CB"] += item.quaCo
                        curSms.Xac["3CB"] += item.xac
                        break;
                    case '7Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CB"] += item.quaCo
                        curSms.Xac["2CB"] += item.xac
                        break;
                    case '8Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CB"] += item.quaCo
                        curSms.Xac["2CB"] += item.xac
                        break;
                    case '7Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CB"] += item.quaCo
                        curSms.Xac["3CB"] += item.xac
                        break;
                    case 'DaT':
                        curSms.TienTrung["da"] += item.thuong
                        curSms.Trung["da"] += item.trung

                        curSms.QuaCo["da"] += item.quaCo
                        curSms.Xac["da"] += item.xac
                        break;
                    case 'Dau2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CDD"] += item.quaCo
                        curSms.Xac["2CDD"] += item.xac
                        break;
                    case 'Dau4C':
                        curSms.TienTrung["4C"] += item.thuong
                        curSms.Trung["4C"] += item.trung

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        break;
                    case 'DaX':
                        curSms.TienTrung["dx"] += item.thuong
                        curSms.Trung["dx"] += item.trung

                        curSms.QuaCo["dx"] += item.quaCo
                        curSms.Xac["dx"] += item.xac
                        break;
                    case 'Duoi2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CDD"] += item.quaCo
                        curSms.Xac["2CDD"] += item.xac
                        break;
                    case 'Duoi4C':
                        curSms.TienTrung["4C"] += item.thuong
                        curSms.Trung["4C"] += item.trung

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        break;
                    case 'Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.Trung["2C"] += item.trung

                        curSms.QuaCo["2CB"] += item.quaCo
                        curSms.Xac["2CB"] += item.xac
                        break;
                    case 'Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CB"] += item.quaCo
                        curSms.Xac["3CB"] += item.xac
                        break;
                    case 'Lo4C':
                        curSms.TienTrung["4C"] += item.thuong
                        curSms.Trung["4C"] += item.trung

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        break;
                    case 'XC':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CXC"] += item.quaCo
                        curSms.Xac["3CXC"] += item.xac
                        break;
                    case 'XcDau':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CXC"] += item.quaCo
                        curSms.Xac["3CXC"] += item.xac
                        break;
                    case 'XcDuoi':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.Trung["3C"] += item.trung

                        curSms.QuaCo["3CXC"] += item.quaCo
                        curSms.Xac["3CXC"] += item.xac
                        break;
                    case 'Xi2':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.Trung["XMB"] += item.trung

                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        break;
                    case 'Xi3':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.Trung["XMB"] += item.trung

                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        break;
                    case 'Xi4':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.Trung["XMB"] += item.trung

                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        break;
                    default:
                        console.log('Bổ xung loại cược mới', loaiCuocId)
                }
            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoiSauPt = 0;
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoiSauPt += TinhTienHoi(sms.message)
    })
    const laiLoSauPt = laiLo / 100 * (100 - phanTramThau)
    if (messages.length > 1) {
        if (laiLo > 0) {
            zSms += "\r\nTổng cộng thu:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            zSms += "\r\nTổng cộng bù:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            zSms += "\r\nTổng cộng hoà"
        }
    }
    console.log(zSms)
    return zSms;
}